// extracted by mini-css-extract-plugin
export default {"banner":"ZooClub_banner__frZO4","buttonDis":"ZooClub_buttonDis__fO9n+","cubIcon":"ZooClub_cubIcon__B28vg","zooTitle":"ZooClub_zooTitle__XLw4q"};